/**
 * Dashboard API Service
 * 
 * Placeholder implementations for Vivre Control Plane dashboard endpoints.
 * Replace with real API calls when backend is ready.
 */

import axiosInstance from './axiosInstance';

// ─── Helper: Simulate API delay ──────────────────────────────────────────────

const delay = (ms = 500) => new Promise((resolve) => setTimeout(resolve, ms));

// ─── Dashboard API Functions ─────────────────────────────────────────────────

/**
 * GET /v1/dashboard/kpis
 * Platform-wide KPI summary
 */
export const getKpis = async () => {
  // TODO: Replace with real API call
  // return axiosInstance.get('/dashboard/kpis');

  await delay(400);

  return {
    data: {
      totalTenants: 7,
      activeTenants: 3,
      suspendedTenants: 1,
      provisioningTenants: 1,
      maintenanceTenants: 1,
      offboardingTenants: 1,
      avgHealthScore: 72,
      monthlyRevenue: 48500,  // in dollars
      lastUpdated: new Date().toISOString(),
    },
  };
};

/**
 * GET /v1/dashboard/activity
 * Recent platform activity feed
 */
export const getRecentActivity = async (params = {}) => {
  // TODO: Replace with real API call
  // return axiosInstance.get('/dashboard/activity', { params });

  await delay(300);

  return {
    data: [
      {
        id: 'act-001',
        type: 'tenant_created',
        tenantName: 'Umbrella Digital',
        description: 'New tenant provisioning started',
        timestamp: '2025-01-10T12:00:00Z',
        actor: 'admin@vivre.io',
      },
      {
        id: 'act-002',
        type: 'status_changed',
        tenantName: 'Initech LLC',
        description: 'Tenant suspended due to payment failure',
        timestamp: '2025-01-08T09:30:00Z',
        actor: 'system',
      },
      {
        id: 'act-003',
        type: 'plan_upgraded',
        tenantName: 'Wayne Media',
        description: 'Plan upgraded from Starter to Growth',
        timestamp: '2025-01-05T15:20:00Z',
        actor: 'billing@vivre.io',
      },
      {
        id: 'act-004',
        type: 'alert_triggered',
        tenantName: 'Stark Streaming',
        description: 'Maintenance window started - DB migration',
        timestamp: '2025-01-04T02:00:00Z',
        actor: 'system',
      },
      {
        id: 'act-005',
        type: 'status_changed',
        tenantName: 'Hooli TV',
        description: 'Offboarding initiated - customer cancellation',
        timestamp: '2025-01-02T11:15:00Z',
        actor: 'support@vivre.io',
      },
    ],
  };
};

/**
 * GET /v1/dashboard/health-summary
 * Quick health overview across all tenants
 */
export const getHealthSummary = async () => {
  // TODO: Replace with real API call
  // return axiosInstance.get('/dashboard/health-summary');

  await delay(300);

  return {
    data: {
      healthy: 3,
      warning: 2,
      critical: 1,
      unknown: 1,
      activeIncidents: 0,
      slaBreaches: 0,
      lastChecked: new Date().toISOString(),
    },
  };
};
